<div class="header-actions">
  <button class="btn-arrow" (click)="onBack()">
    <mat-icon svgIcon="arrow"></mat-icon>
  </button>
  <h3 class="header-title" *ngIf="showTitle">{{ title }}</h3>
  <div class="right-actions">
    <button *ngIf="showInfo" class="btn-info" (click)="onInfo()">
      <mat-icon svgIcon="info"></mat-icon>
    </button>
    <button *ngIf="showFavorite" id="btn-favorite" [class.active]="isFavorite" (click)="onFavorite()">
      <mat-icon svgIcon="favorite-border"></mat-icon>
    </button>
    <button *ngIf="showShare" class="btn-share" (click)="onShare()">
      <mat-icon svgIcon="share"></mat-icon>
    </button>
  </div>
</div>
